import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const toNumberOrUndef = (v) => {
  if (v === null || v === undefined || v === "") return undefined;
  const n = Number(v);
  return Number.isFinite(n) ? n : undefined;
};

const toStringOrUndef = (v) => {
  if (v === null || v === undefined) return undefined;
  const s = String(v).trim();
  return s ? s : undefined;
};

// ✅ Make Order (كل الحقول اختيارية ماعدا payment_method لو حابب)
export const makeOrder = async ({
  payment_method = "cash",
  phone,
  country_id,
  governorate_id,
  city_id,
  address,
  postal_code,
  notes,
  shipping_cost,
  discount,
} = {}) => {
  // لو عايز حتى payment_method يبقى اختياري شيل السطر ده
  if (!payment_method) throw new Error("payment_method is required");

  // نبني payload و نشيل أي key قيمته undefined
  const payload = {
  payment_method: payment_method || "cash",
  phone: toStringOrUndef(phone),
  country_id: toNumberOrUndef(country_id),
  governorate_id: toNumberOrUndef(governorate_id),
  city_id: toNumberOrUndef(city_id),       // ممكن تبقى undefined => مش هتتبعت
  address: toStringOrUndef(address),
  postal_code: toStringOrUndef(postal_code),
  notes: toStringOrUndef(notes),
  shipping_cost: toNumberOrUndef(shipping_cost), // لو السيرفر طالبها لازم تبعتها
  discount: toNumberOrUndef(discount),
};

Object.keys(payload).forEach((k) => payload[k] === undefined && delete payload[k]);


  const res = await api.post("/user/make/order", payload, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
  });

  return res.data;
};
// ✅ Get My Orders
export const getMyOrders = async (params = {}) => {
  const res = await api.get("/user/my/orders", {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    // اختياري (لأن api عندك بيحط api_password تلقائيًا)
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return res.data;
};
// ✅ Get Order Info (تفاصيل طلب واحد)
export const getOrderInfo = async (orderId, params = {}) => {
  if (!orderId) throw new Error("orderId is required");

  const res = await api.get(`/user/order/info/${orderId}`, {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    // لو api عندك بيضيف api_password تلقائيًا، تقدر تشيل api_password من هنا
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return res.data;
};
// ✅ Cancel Order (إلغاء طلب)
export const cancelOrder = async (orderId, params = {}) => {
  if (!orderId) throw new Error("orderId is required");

  const res = await api.get(`/user/cancel/order/${orderId}`, {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    // لو api instance بيضيف api_password تلقائيًا، تقدر تشيل السطر ده
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return res.data;
};
// ✅ Get My Payments (مدفوعاتي)
export const getMyPayments = async (params = {}) => {
  const res = await api.get("/user/my/payments", {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return res.data;
};
// ✅ Return Order (إرجاع طلب)
export const returnOrder = async (orderId, params = {}) => {
  if (!orderId) throw new Error("orderId is required");

  const res = await api.get(`/user/return/order/${orderId}`, {
    headers: {
      Accept: "application/json",
      ...getAuthHeaders(),
    },
    // لو api instance بيضيف api_password تلقائيًا تقدر تشيل السطر ده
    params: {
      api_password: "EcommercApp@2026_$",
      ...params,
    },
  });

  return res.data;
};
